import React from 'react';

import {SvgProps} from '../../helpers/type';

const Download = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="0.713477"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                fill="#EDFCF2"
                fillOpacity="0.5"
            />
            <path
                d="M30.0378 20.2154H25.9025V14.0123L19.6995 14.0123V20.2154H15.5641L22.801 27.4522L30.0378 20.2154ZM15.5641 29.5199V31.5876H30.0378V29.5199H15.5641Z"
                fill="#5D847F"
            />
            <rect
                x="0.713477"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                stroke="#E8EDEC"
                strokeWidth="1.425"
            />
        </svg>
    );
};

export default Download;
